// extracted by mini-css-extract-plugin
export default {"legenda-capag":"Capag_legenda-capag__YOXCB","legenda-estados":"Capag_legenda-estados__bo+z8"};